module.exports = __webpack_public_path__ + "img/5.0b2c3f7f.png";